/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import Markdown from 'markdown-to-jsx';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import AIStateIndicator from '../../FlexibleCard/components/blocks/ai-summary-block/ai-state-indicator';
import UList from './ulist';
var AITooltipIcon = function AITooltipIcon() {
  return jsx(AIStateIndicator, {
    appearance: "icon-only",
    state: "done",
    testId: "ai-tooltip"
  });
};
var AISummaryCSSStyles = css({
  fontSize: '0.75rem',
  lineHeight: '1rem',
  wordWrap: 'break-word',
  wordBreak: 'break-word',
  whiteSpace: 'normal',
  WebkitUserSelect: 'text',
  MozUserSelect: 'text',
  MsUserSelect: 'text',
  userSelect: 'text'
});
/**
 * A component to render a response from AI in markdown text.
 * @internal
 * @param {AISummaryProps} AISummaryProps
 */

var AISummary = function AISummary(_ref) {
  var _ref$content = _ref.content,
    content = _ref$content === void 0 ? '' : _ref$content,
    _ref$showIcon = _ref.showIcon,
    showIcon = _ref$showIcon === void 0 ? false : _ref$showIcon,
    iconComponent = _ref.iconComponent,
    overrideCss = _ref.overrideCss,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'ai-summary' : _ref$testId,
    _ref$minHeight = _ref.minHeight,
    minHeight = _ref$minHeight === void 0 ? 0 : _ref$minHeight;
  if (!content && minHeight === 0) {
    return null;
  }
  return jsx(Markdown, {
    "data-testid": testId,
    css: [AISummaryCSSStyles, overrideCss],
    children: showIcon ? "".concat(content, "&nbsp;<Icon />") : content,
    options: {
      forceWrapper: true,
      overrides: {
        Icon: iconComponent !== null && iconComponent !== void 0 ? iconComponent : AITooltipIcon,
        ul: UList
      }
    },
    style: {
      minHeight: minHeight
    }
  });
};
export default AISummary;